import { defineView } from "eddev/views"
import { ContentBlocks } from "eddev/blocks"
import { useSubtheme } from "@hooks/useSubtheme"
import { getNextSiblingPage } from "@utils/getNextSiblingPage"
import { NextPagePreviewContext } from "@hooks/useNextPagePreview"

export const meta: ViewMeta = {
  templateName: "Data: EV Index",
}

export default defineView("templates/ev-index", (props) => {
  useSubtheme("blackHeader")
  const nextPage = getNextSiblingPage(props.page?.parent?.node, props.page?.databaseId, "Data: EV Index")
  return (
    <div className="[&>div]:z-0">
      <ContentBlocks blocks={props.page?.contentBlocks} />
      {nextPage && (
        <NextPagePreviewContext.Provider value={true}>
          <ContentBlocks blocks={nextPage.previewBlocks} />
          <div className="w-full h-6" />
        </NextPagePreviewContext.Provider>
      )}
    </div>
  )
})
